import { HttpErrorResponse } from '@angular/common/http';
import { Constants, IEnvironmentConfiguration, LogLevels } from '../app/models';

export const environment: IEnvironmentConfiguration = {
  idleTimeThreshold: 15,
  production: false,
  apiVersion: '1.0',
  version: 'QA',
  siteKey: '6LdOE8QUAAAAAEXSemmg__Km9wazSxhWQJyhUjaM',
  gtagPropertyId: 'G-JXD7ZTB0EZ',
  useCallbackFlag: true,
  origin: 'qa-survey.heartstylesapp.com',
  mobileCallbackUrl: '/redirect-close.html',
  authSettings: {
    authLogger: {
      level: LogLevels.DEBUG,
      logger: console
    },
    authority: 'https://identityqa.heartstylesapp.com',
    client_id: '9f76edfc-b27e-4ee1-97ac-542af30d24e0',
    response_type: 'id_token token',
    scope: 'openid profile roles Heartstyles.Api Heartstyles.Survey.Api',
    redirect_uri: `${window.location.origin}/callback.html`,
    post_logout_redirect_uri: `${window.location.origin}/signout-callback`,
    silent_renew_uri: `${window.location.origin}/renew-callback.html`,
    silent_redirect_uri: `${window.location.origin}/renew-callback.html`,
    automaticSilentRenew: true,
    startCheckSession: true
  },
  featureToggle: {
    openPacks: Constants.FEATURE_ON,
    selfRegistration: Constants.FEATURE_ON
  },
  apiConfig: {
    agreementApi: '/agreements',
    antiForgeryTokenApi: '/system/antiforgerytoken',
    apiUrl: 'https://apiqa.heartstylesapp.com/api',
    surveyApiUrl: 'https://qa-surveyapi.heartstylesapp.com/api',
    checkEmailAddressApi: '/identity/isemailaddressvalid',
    checkEmailAddressProfileApi: '/profile/isemailaddressvalid',
    communicationsApi: '/communications',
    compareReportsApi: '/compareReports',
    demographicsApi: '/demographics',
    downloadApi: '/downloads',
    enrichedUserDetailsApi: '/enricheduserdetails',
    hubApi: '/hubs/usernotificationhub',
    impersonationValidationApi: '/tokenvalidation',
    intercomId: 'm7san35s',
    invitationsApi: '/invitations/sendinvitations',
    invitationsReminderApi: '/invitations',
    journalingApi: '/journaling',
    journalingQuadrantApi: '/getbyquadrantid',
    languagesApi: '/languages',
    mostRecentApi: '/surveys/mostrecent',
    quadrantsApi: '/quadrants',
    questionResponseApi: '/questionResponses',
    questionsApi: '/questions',
    participantsGroupsApi: '/participantgroups',
    participantsValidationApi: '/participantsvalidation',
    previousRespondentsApi: '/respondents/getpreviousrespondents',
    profileApi: '/profile',
    regenerateApi: '/reports/regenerate',
    registerApi: '/identity/register',
    registrationApi: '/registration',
    registrationValidateRegistrationCodeApi: '/registration/validateregistrationcode',
    registrationValidationApi: '/registrationvalidation',
    reportsApi: '/reports',
    reportsOnlineApi: '/reports/personaledition',
    reportsRequestTokenApi: '/reports/getreportrequesttoken',
    requestPasswordResetApi: '/profile/requestPasswordReset',
    resendRegistrationValidationEmailApi: '/identity/resendregistrationvalidationemail',
    resolveTokenApi: '/identity/resolvetoken',
    respondentAccept: '/identity/RespondentAccept',
    respondentDeclineApi: '/respondentvalidation/respondentdecline',
    respondentsApi: '/respondents',
    respondentSurvey: '/respondentsurveys',
    respondentValidationApi: '/respondentvalidation',
    responseApi: '/surveyresponses',
    resultsApi: '/results',
    setPasswordUrl: 'https://identityserverurl/account/setpassword',
    settingsApi: '/settings',
    surveysApi: '/surveys',
    systemApi: '/system',
    userDemographicsApi: '/userdemographicvalues',
    validateRespondentEmailApi: '/respondents/validaterespondentemail',
    webClient: 'https://qa.heartstylesapp.com',
    welcomeApi: '/welcome',
    userDetailsApi: '/userDetails',
  },
  retryConfig: {
    initialInterval: 1000,
    maxRetries: 5,
    resetOnSuccess: true,
    shouldRetry: (error: any) => {
      if ((error as HttpErrorResponse).status !== undefined) {
        return error.status >= 500;
      }
      return true;
    }
  },
};
